import { measure, radius, typo } from "@obs/tokens/index.stylex.ts";
import type { StyleXStyles } from "@stylexjs/stylex";
import * as stylex from "@stylexjs/stylex";

export type TagPrimitiveProps = {
	label: string;
	sx?: StyleXStyles;
} & Omit<React.HTMLAttributes<HTMLSpanElement>, "className" | "style">;

export type TagProps = Pick<TagPrimitiveProps, "label" | "sx"> &
	Omit<React.HTMLAttributes<HTMLSpanElement>, "className" | "style">;

const styles = stylex.create({
	root: {
		display: "inline-flex",
		paddingBlock: measure.spacingGapMin,
		paddingInline: measure.spacingGapNarrow,
		borderRadius: radius.weak,
		fontFamily: typo.fontFamily,
		fontSize: typo.bodySmallFontSize,
		fontWeight: typo.bodySmallFontWeight,
		lineHeight: typo.bodySmallLineHeight,
	},
	label: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
});

export const TagPrimitive = ({ label, sx, ...htmlProps }: TagPrimitiveProps) => {
	return (
		<span {...htmlProps} {...stylex.props(styles.root, sx)}>
			<span {...stylex.props(styles.label)}>{label}</span>
		</span>
	);
};
